import React from 'react';

class OrgPrivacyIdCapsule extends React.Component {

  constructor(props) {

    super(props);
    this.state = {
      privacyId: props.privacyId ? props.privacyId : '',
    };

    this.fieldUpdateMethods = {
      privacyId: props.onChange,
    };

    this.onKeyPressedGen = this.onKeyPressedGen.bind(this);
    this.onClickGen = this.onClickGen.bind(this);
  }

  onKeyPressedGen(fieldName) {
    return (e) => {
      return this.setState({ [fieldName]: e.target.value });
    };
  }

  onClickGen(fieldName) {
    return (e) => {
      return this.fieldUpdateMethods[fieldName](this.state[fieldName]);
    };
  }

  render() {

    return (
      <div className="row" style={{ marginTop: '2%' }}>
        <div className="col-12">
          <span className="text-left">
            <strong>Privacy ID</strong>
          </span>
          <div className="row">
            <div className="col-10">
              <input type="text" className="form-control" value={this.state.privacyId} onChange={this.onKeyPressedGen('privacyId') } />
            </div>
            <div className="col-2">
                <button className="btn btn-small btn-default" onClick={this.onClickGen('privacyId')}><i className="fas fa-check"></i></button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default OrgPrivacyIdCapsule;
